module.exports = __webpack_public_path__ + "static/media/sild.bb7f3080.mp3";